module.exports = __webpack_public_path__ + "static/ryan-holiday-54d60be1182f74a5ccdb58f78289e8f3.jpg";